module.exports = __webpack_public_path__ + "img/iconSystemSupplier.d8575b94.svg";